import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getRiderContacts } from '../api/services/Riders';
import { RiderContact } from '../types/rider';

interface IUseRideContactsQuery {
  riderSlug: string;
  page: number;
  perPage: number;
}

export const useRiderContactsQuery = ({ riderSlug, page, perPage }: IUseRideContactsQuery) => {
  return useApiGet<{ data: RiderContact[] }>(
    ['riderContacts', riderSlug, page],
    () => getRiderContacts({ riderId: riderSlug, page: page, perPage: perPage }),
    {
      enabled: true,
      mutationKey: 'page',
    }
  );
};
